<template>
  <section class="hero">
    <div class="hero__inner">
      <div class="hero__emblems">
        <img class="hero__emblem" src="../../assets/images/kz_logo.png" :alt="$t('chpo.decision.altLeft')" />
        <img class="hero__emblem" src="../../assets/images/knb_logo.png" :alt="$t('chpo.decision.altRight')" />
      </div>

      <div class="hero__content">
        <h1 class="hero__title">{{ $t('chpo.decision.title') }}</h1>
        <p class="hero__subtitle">{{ $t('chpo.decision.subtitle') }}</p>
        <ActionButton
          class="hero__cta"
          :color="'#2A8A1B'"
          :text="$t('chpo.decision.next')"
          @click="goNext"
        />
      </div>
    </div>
  </section>
</template>

<script>
import ActionButton from '@/components/widgets/ActionButton.vue'

export default {
  name: 'DecisionStartView',
  components: { ActionButton },
  methods: {
    goNext() {
      this.$router.push('/chpo/personnel')
    }
  }
}
</script>

<style scoped>
.hero {
  background: #3EC3FF;
  padding: 48px 24px 64px;
  display: flex;
  flex: 1 1 auto;
}

.hero__inner {
  margin: 0 auto;
  max-width: 1120px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 28px;
}

.hero__emblems {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.hero__emblem {
  width: 220px;
  height: auto;
  object-fit: contain;
}

.hero__content {
  text-align: center;
  display: grid;
  row-gap: 28px;
  justify-items: center;
}

.hero__title,
.hero__subtitle {
  margin: 0;
  color: #FFFFFF;
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-size: 43px;
  line-height: 60.2px;
}
.hero__title {
  font-weight: 700;
}
.hero__subtitle {
  font-weight: 400;
}

.hero__cta {
  margin-top: 8px;
  min-width: 220px;
}
</style>